import { Subscription } from 'rxjs';
import Swal from 'sweetalert2';
import { ContaService } from './../../services/financeiro/conta.service';
import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import * as jsPDF from 'jspdf';
import 'jspdf-autotable';
import { AuthService } from 'src/app/services/vos/auth.service';
import { GerarPdfOsService } from 'src/app/services/utils/gerar-pdf-os.service';
import { Funcoes } from '../funcoes';
import * as moment from 'moment';
import { ViewPackageMedicaoComponent } from 'src/app/financeiro/new-medicao/view-package-medicao/view-package-medicao.component';

@Component({
  selector: 'app-view-medicao',
  templateUrl: './view-medicao.component.html',
  styleUrls: ['./view-medicao.component.css']
})
export class ViewMedicaoComponent implements OnInit {
  usuario: any
  logo: any = [];
  contas: any;
  inscricao: Subscription;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ViewMedicaoComponent>,
    private dialog: MatDialog,
    private authService: AuthService,
    private contaService: ContaService,
    private pdfService: GerarPdfOsService
  ) { }

  ngOnInit() {
    this.pegarUsuario()
    console.log(this.data);
  }
  pegarUsuario() {
    this.usuario = JSON.parse(this.authService.getUserLoggedIn())
    if (this.usuario?.user.pessoa.profissional) this.logo = this.usuario.user.pessoa.profissional.empresa
    if (this.usuario?.user.pessoa.cliente) this.logo = this.usuario.user.pessoa.cliente.empresa
    if (this.usuario?.user.pessoa.responsavel) this.logo = this.usuario.user.pessoa.responsavel.empresa
  }

  gerarContaPagar() {

    let conta = {
      id: "",
      empresa_id: this.usuario.user.pessoa.profissional.empresa_id,
      conta_id: "",
      contasbancaria_id: "",
      numeroboleto: "",
      formapagamento: "",
      datavencimento: "",
      datapagamento: "",
      valorconta: this.data.valor,
      status: false,
      tipopagamento: "A Vista",
      valorpago: "",
      pagamentoparcial: 0,
      observacao: "",
      numeroconta: "",
      anexo: ""
    }


    this.contas = {
      id: "",
      empresa_id: this.usuario.user.pessoa.profissional.empresa_id,
      tipopessoa: "Cliente",
      pessoa_id: this.data.cliente.id,
      natureza_id: "",
      valortotalconta: this.data.valor,
      tipoconta: "Pagar",
      historico: "",
      status: false,
      nfe: '',
      quantidadeconta: 1,
      valorpago: "",
      tipocontapagamento: "A Vista",
      dataemissao: this.data.dataSolicitacao,
      dataemissaofim: "",
      datavencimento: "",
      datavencimentofim: "",
      pagamentos: []
    }

    this.contas.pagamentos.push(conta);

    this.inscricao = this.contaService.save(this.contas, this.usuario).subscribe(res => {
      Swal.fire("Cadastrado com sucesso!", "", "success")
    })
  }

  getTotalPackages() {
    return this.data?.medicao_pacotes?.reduce((acc, pkg) => {
      return acc + pkg.subtotal
    }, 0);
  }

  viewPackage(item) {
    this.dialog.open(ViewPackageMedicaoComponent, {
      data: {
        package: item,
        medicao: this.data
      }
    });
  }

  downloadPdf() {
    console.log(this.data)
    var doc = new jsPDF();
    let pdf_pages = doc.internal.pages;
    moment.locale('pt');

    const dataAtual = this.data.dataAtual;
    const company = this.data.empresa.empresa_dado[0] ?? null;
    let pixData = this.data.empresa.empresa_dado.find(x => x.pix_key != null) ?? null;


    (doc as any).autoTable({
      body: [[`Paciente: ${this.data.contract ? this.data.contract.paciente?.pessoa?.nome : ''}`]],
      startY: 35,
      theme: 'grid',
      tableWidth: 'auto',
    });

    (doc as any).autoTable({
      body: [[`Observação: ${this.data.observacao ? this.data.observacao : ''}`]],
      startY: doc.lastAutoTable.finalY,
      theme: 'grid',
      tableWidth: 'auto',
    });

    if (this.data.contract.company_id != 1) {
      if (company) {
        (doc as any).autoTable({
          body: [[`Dados Bancário: Banco: ${company.nome} | Conta: ${company.conta}-${company.digito_conta} | Agência: ${company.agencia}-${company.digito_agencia}`]],
          startY: doc.lastAutoTable.finalY,
          theme: 'grid',
          tableWidth: 'auto',
        });
      }

      if (pixData) {
        (doc as any).autoTable({
          body: [[`PIX: Banco: ${pixData.nome} | Conta: ${pixData.conta}-${pixData.digito_conta} | Agência: ${pixData.agencia}-${pixData.digito_agencia} | Tipo Chave: ${pixData.type_pix_key} | Chave: ${pixData.pix_key}`]],
          startY: doc.lastAutoTable.finalY,
          theme: 'grid',
          tableWidth: 'auto',
        });
      }
    }

    let body = [];
    for (let medicao_servico of this.data.medicao_servicos) {
      body.push([
        medicao_servico.servico.descricao,
        medicao_servico.quantidade,
        medicao_servico.atendido,
        new Funcoes().getFormattedPrice(medicao_servico.valor),
        new Funcoes().getFormattedPrice(medicao_servico.subtotal)
      ])
    }
    (doc as any).autoTable({
      head: [['Serviço', 'Qtd. Solicitada', 'Qtd. Atendida', 'Valor Unitário', 'Valor Total']],
      body,
      startY: doc.lastAutoTable.finalY + 5,
      margin: { top: 35 },
      headStyles: {
        fillColor: [211, 211, 211],
        halign: 'center',
        textColor: [0, 0, 0]
      },
      theme: 'grid',
      tableWidth: 'auto',
    });
    body = [];

    for (let medicao_produto of this.data.medicao_produtos) {
      body.push([
        medicao_produto.ml_products_company.ml_products_table_versions_prices.product.description,
        medicao_produto.quantidade,
        medicao_produto.atendido,
        new Funcoes().getFormattedPrice(medicao_produto.valor),
        new Funcoes().getFormattedPrice(medicao_produto.subtotal)
      ])
    }
    (doc as any).autoTable({
      head: [['Produto', 'Qtd Solicitada', 'Qtd Atendida', 'Valor Unitário', 'Valor Total']],
      body,
      startY: doc.lastAutoTable.finalY + 5,
      margin: { top: 35 },
      headStyles: {
        fillColor: [211, 211, 211],
        halign: 'center',
        textColor: [0, 0, 0],
      },
      theme: 'grid',
      tableWidth: 'auto',
    });

    (doc as any).autoTable({
      body: [[`Total: ${new Funcoes().getFormattedPrice(this.data.valor)}`]],
      startY: doc.lastAutoTable.finalY + 5,
      theme: 'grid',
      tableWidth: 'auto',
    });

    for (let i = 1; i < pdf_pages.length; i++) {
      doc.setPage(i)
      this.pdfService.headerFooterPage(doc, i, `Relatório de Medição - ${moment(dataAtual).format('MMMM/yyyy')}`, this.usuario, this.logo)
    }

    doc.save(`${dataAtual} Relatório de Medição ${this.data.contract.paciente.pessoa.nome}.pdf`);
  }

  ngOnDestroy() {
    if (this.inscricao) this.inscricao.unsubscribe();
  }
}
